import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";
import { UnifiedButton, UnifiedButtonFragment } from "../unifiedButton";

export const LocalizedSpotlight = z.object({
  __typename: z.literal("LocalizedSpotlight"),
  sys: Sys,
  title: z.string().nullable(),
  image: Image.nullable(),
  imageEn: Image.nullable(),
  buttonsCollection: z
    .object({
      items: z.array(UnifiedButton).nullish(),
    })
    .nullish(),
});

export type LocalizedSpotlight = z.infer<typeof LocalizedSpotlight>;

export const LocalizedSpotlightFragment = gql`
  fragment LocalizedSpotlightFragment on LocalizedSpotlight {
    __typename
    sys {
      ...SysFragment
    }
    title
    image {
      ...ImageFragment
    }
    imageEn: image(locale: "en") {
      ...ImageFragment
    }
    buttonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }
  }
  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
